import React from 'react';
import OSRSEnergyDashboard from './OSRSEnergyDashboard';

function App() {
  return <OSRSEnergyDashboard />;
}

export default App;
